import React from 'react';
import './SearchBar.scss';
import { SearchIcon } from 'views/components/Icons/SearchIcons';
import {
  AdvertisersPageCache,
  UpdateCache,
  AdvertisersByProductPageCache
} from 'models/interfaces/PageCache';

interface SearchBarProps {
  pageCache: AdvertisersPageCache | AdvertisersByProductPageCache;
  updateCache: UpdateCache;
  loading: boolean;
  onKeyPressEvent: (data: any) => void;
  onChangeEvent: (data: any) => void;
  onClickEvent: () => void;
}

const SearchBar = ({
  pageCache,
  updateCache,
  loading,
  onKeyPressEvent,
  onChangeEvent,
  onClickEvent
}: SearchBarProps) => {
  return (
    <div className="search-bar__container">
      {loading && (
        <div className="search-bar__loader">
          <div className="spinner">
            <div className="rect1" />
            <div className="rect2" />
            <div className="rect3" />
          </div>
        </div>
      )}
      <input
        className="form-control form-control-sm search-bar__form pl-3"
        type="text"
        value={pageCache.preSearchTerm}
        onChange={e => onChangeEvent(e.target.value)}
        onKeyPress={e => onKeyPressEvent(e)}
        onClick={() => onClickEvent()}
      />
      <div className="search-bar__icon" onClick={() => onClickEvent()}>
        <SearchIcon />
      </div>
    </div>
  );
};

export default SearchBar;
